import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  infoBlocks: FelaCSS;
  infoBlocksV2: FelaCSS;
  infoBlocksColumn: FelaCSS;
  infoWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingTop: spacing[6],

    maxWidthTabletSm: {
      paddingHorizontal: spacing[4],
      paddingTop: spacing[4],
      paddingBottom: spacing[2],
      borderBottom: 'none',
    },
  },

  infoBlocks: {
    flexDirection: 'row',
    flexWrap: 'wrap',

    maxWidthTabletSm: {
      flexDirection: 'column',
    },
  },

  infoBlocksV2: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    width: '100%',
    gap: spacing[4],
    marginBottom: spacing[4],

    desktopDesign: {
      gridTemplateColumns: '1fr 1fr',
      marginTop: spacing[2],
    },
  },

  infoBlocksColumn: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: spacing[4],
  },

  infoWrap: {
    marginBottom: '24px',
    paddingRight: '12px',
    width: '50%',

    maxWidthTabletSm: {
      marginBottom: '8px',
      paddingRight: '0',
      width: '100%',
    },

    ':nth-of-type(even)': {
      paddingLeft: '12px',
      paddingRight: '0',

      maxWidthTabletSm: {
        paddingLeft: '0',
      },
    },
  },
});

export default styles;
